/**
 * Utility to check if the current user has a specific permission.
 */
export const checkPermission = (permissionCode: string): boolean => {
  const userStr = localStorage.getItem('atelier_bassoum_user');
  if (!userStr) return false;

  try {
    const user = JSON.parse(userStr);
    
    // Superadmin has all permissions
    if (user.role === 'superadmin') return true;
    
    // Check if the code exists in the user's permissions array
    const permissions: string[] = user.permissions || [];
    return permissions.includes(permissionCode);
  } catch (err) {
    console.error("Error checking permissions:", err);
    return false;
  }
};

/**
 * Common permission constants to avoid typos
 */
export const PERMISSIONS = {
  DASH_ATELIER: 'dash_atelier',
  CMD_CREER: 'cmd_creer',
  VENTE_CREER: 'vente_creer',
  CLIENT_VOIR: 'client_voir',
  STOCK_VOIR: 'stock_voir',
  STOCK_MODIFIER: 'stock_modifier',
  PAIE_VOIR: 'paie_voir',
  CA_VOIR: 'ca_voir',
  USER_VOIR: 'user_voir',
  USER_GERER: 'user_gerer',
  EDIT_COMMANDE: 'cmd_modifier',
  DELETE_COMMANDE: 'cmd_valider',
  MANAGE_SUPPLIERS: 'fourn_gerer',
  FOURN_VOIR: 'fourn_voir',
  FOURN_GERER: 'fourn_gerer',
  EDIT_CLIENT: 'client_voir',
  DELETE_CLIENT: 'client_voir',
  DELETE_PAIE: 'paie_valider',
  CANCEL_COMMANDE: 'cmd_valider',
  CANCEL_VENTE: 'vente_creer',
  DELETE_VENTE: 'vente_creer',
  RAPPORT_PERSONNEL: 'rapport_personnel',
  RAPPORT_STOCKS: 'rapport_stocks',
  RAPPORT_CA: 'rapport_ca',
  CONFIG_ENTREPRISE: 'config_entreprise',
  MESURE_VOIR: 'mesure_voir',
  MESURE_CREER: 'mesure_creer',
  MESURE_MODIFIER: 'mesure_modifier',
  CONFIG_MESURES: 'config_mesures'
};
